import { render, staticRenderFns } from "./EnclosingWallsDashboardItem.vue?vue&type=template&id=7ebe82a0&scoped=true"
import script from "./EnclosingWallsDashboardItem.vue?vue&type=script&lang=js"
export * from "./EnclosingWallsDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./EnclosingWallsDashboardItem.vue?vue&type=style&index=0&id=7ebe82a0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebe82a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ebe82a0')) {
      api.createRecord('7ebe82a0', component.options)
    } else {
      api.reload('7ebe82a0', component.options)
    }
    module.hot.accept("./EnclosingWallsDashboardItem.vue?vue&type=template&id=7ebe82a0&scoped=true", function () {
      api.rerender('7ebe82a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/EnclosingWallsDashboardItem.vue"
export default component.exports